export default __webpack_public_path__ + "static/img1@2x-3655524a13cb7b23d6925eeba8e9cdf5.jpg";